module.exports = __webpack_public_path__ + "static/media/costcase11.f1d09fc5.png";